import { Outlet, useNavigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import AdminShell from "../components/admin/AdminShell";
import { setNavigator } from "../utils/fetchWrapper";

const adminQueryClient = new QueryClient();

function AdminLayout() {
   const navigate = useNavigate();
   setNavigator(navigate);

   return (
      <QueryClientProvider client={adminQueryClient}>
         <AdminShell />
      </QueryClientProvider>
   );
}

export default AdminLayout;
